export default "__VITE_ASSET__DK4MkD8R__"